import React, {
  useContext,
  useRef,
  useEffect,
  useState,
  useLayoutEffect,
  isValidElement,
  useCallback,
} from 'react';
import cx from 'classnames';

import chainHandlers from '@mc/fn/chainHandlers';

import TabContext from './TabContext';
import getTabId from './getTabId';
import stylesheet from './TabList.css';

export type TabListProps = {
  children?: React.ReactNode;
  className?: string;
  onKeyDown?: $TSFixMeFunction;
};

const TabList = ({
  children,
  onKeyDown,
  className,
  ...props
}: TabListProps) => {
  const {
    // @ts-expect-error TS(2339) FIXME: Property 'currentIndex' does not exist on type 'Ta... Remove this comment to see the full error message
    currentIndex,
    // @ts-expect-error TS(2339) FIXME: Property 'id' does not exist on type 'TabContextTy... Remove this comment to see the full error message
    id,
    // @ts-expect-error TS(2339) FIXME: Property 'setCurrentIndex' does not exist on type ... Remove this comment to see the full error message
    setCurrentIndex,
    // @ts-expect-error TS(2339) FIXME: Property 'isManual' does not exist on type 'TabCon... Remove this comment to see the full error message
    isManual,
    // @ts-expect-error TS(2339) FIXME: Property 'focusIndex' does not exist on type 'TabC... Remove this comment to see the full error message
    focusIndex,
    // @ts-expect-error TS(2339) FIXME: Property 'orientation' does not exist on type 'TabC... Remove this comment to see the full error message
    orientation,
    // @ts-expect-error TS(2339) FIXME: Property 'setShowOutline' does not exist on type '... Remove this comment to see the full error message
    setShowOutline,
    // @ts-expect-error TS(2339) FIXME: Property 'updateDisabledMap' does not exist on type '... Remove this comment to see the full error message
    updateDisabledMap,
    // @ts-expect-error TS(2339) FIXME: Property 'variant' does not exist on type '... Remove this comment to see the full error message
    variant,
    // @ts-expect-error TS(2339) FIXME: Property 'moveToIndex' does not exist on type '... Remove this comment to see the full error message
    moveToIndex,
    // @ts-expect-error TS(2339) FIXME: Property 'setTabsCount' does not exist on type '... Remove this comment to see the full error message
    setTabsCount,
    // @ts-expect-error TS(2339) FIXME: Property 'isDisabled' does not exist on type '... Remove this comment to see the full error message
    isDisabled,
  } = useContext(TabContext);
  const tabListRef = useRef();

  const [isRightOverflow, setRightOverflow] = useState(false);
  const [isLeftOverflow, setLeftOverflow] = useState(false);

  const showTabIndicator = variant === 'underline';

  // Show/hide overflow button depending on extended direction
  const setOverflows = () => {
    const el = tabListRef.current;

    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    if (el.scrollWidth > el.clientWidth) {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      setLeftOverflow(el.scrollLeft > 0);
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      setRightOverflow(el.scrollLeft + el.clientWidth < el.scrollWidth);
    } else {
      setLeftOverflow(false);
      setRightOverflow(false);
    }
  };

  useLayoutEffect(() => {
    // Check for overflow on window resize and scroll
    window.addEventListener('resize', setOverflows);

    // And when it loads
    setOverflows();

    // Cleanup
    return () => {
      window.removeEventListener('resize', setOverflows);
    };
  }, []);

  const handleKeyDown = (event: $TSFixMe) => {
    const el = tabListRef.current;
    const tabId = getTabId(id, currentIndex);
    // @ts-expect-error TS(2345) FIXME: Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
    const tabEl = document.getElementById(tabId);

    switch (event.key) {
      case 'ArrowLeft': {
        if (orientation === 'vertical') {
          return;
        }
        event.preventDefault();
        moveToIndex(-1, true);
        // Manually set scroll into view. Sets visibilty on selected tab when navigating left
        // Opted out of using scrollIntoView library due to page jumps
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        el.scrollLeft =
          // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
          tabEl.offsetLeft - (tabEl.clientWidth + el.clientWidth) / 2;
        return;
      }
      case 'ArrowRight': {
        if (orientation === 'vertical') {
          return;
        }
        event.preventDefault();
        moveToIndex(1, true);
        // Manually set scroll into view. Sets visibilty on selected tab when navigating right
        // Opted out of using scrollIntoView library due to page jumps
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        el.scrollLeft = tabEl.offsetLeft + tabEl.clientWidth;
        return;
      }
      case 'ArrowUp':
        if (orientation === 'horizontal') {
          return;
        }
        event.preventDefault();
        moveToIndex(-1, true);
        break;
      case 'ArrowDown':
        if (orientation === 'horizontal') {
          return;
        }
        event.preventDefault();
        moveToIndex(1, true);
        break;
      case 'Home': {
        event.preventDefault();
        moveToIndex(0);
        return;
      }
      case 'End': {
        event.preventDefault();
        moveToIndex(React.Children.count(children) - 1);
        return;
      }
      case ' ':
      case 'Enter': {
        if (isManual) {
          if (isDisabled(focusIndex) === false) {
            setCurrentIndex(focusIndex);
            setShowOutline(false);
            const tabPanel = document.getElementById(`${tabId}:panel`);
            if (tabPanel) {
              event.preventDefault();
              tabPanel.focus({ preventScroll: true });
            }
          }
          return;
        }

        const tabPanel = document.getElementById(`${tabId}:panel`);
        if (tabPanel) {
          event.preventDefault();
          tabPanel.focus({ preventScroll: true });
        }
        break;
      }
      default:
        break;
    }
  };

  const cloned = React.Children.map(children, (child, index) => {
    if (child === null) {
      return null;
    }
    // @ts-expect-error TS(2769) FIXME: No overload matches this call.
    return React.cloneElement(child, { index });
  });

  useEffect(() => {
    /* Purpose of this useEffect is to take all the children of TabList
     * and identify which of them are disabled, create a map with
     * their index and set it to the context. This is used to
     * determine which tabs are disabled and how to handle keyboard
     * navigation.
     */
    const disabledMap: Record<number, boolean> = Object.fromEntries(
      React.Children.toArray(children).map((child, index) => {
        if (!isValidElement(child)) {
          return [index, false];
        }
        return [index, child?.props.disabled ?? false];
      }) ?? [],
    );
    updateDisabledMap(disabledMap);
    setTabsCount(React.Children.count(children));
  }, [children, updateDisabledMap, setTabsCount]);

  useEffect(() => {
    const tablist = tabListRef.current;

    // Remove .focus-within class when click is detected
    function removeFocusWithin() {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      tablist.classList.remove(stylesheet['focus-within']);
      setShowOutline(false);
    }

    // Add .focus-within class when keypress on TabList is detected
    function addFocusWithin() {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      tablist.classList.add(stylesheet['focus-within']);
      setShowOutline(true);
    }

    document.addEventListener('keydown', addFocusWithin, { capture: true });
    document.addEventListener('click', removeFocusWithin, { capture: true });

    // Cleanup
    return () => {
      document.removeEventListener('keydown', addFocusWithin, {
        capture: true,
      });
      document.removeEventListener('click', removeFocusWithin, {
        capture: true,
      });
    };
  }, [setShowOutline]);

  // Used to position the indicator that is animated between tabs
  const [animatedIndicatorPosition, setAnimatedIndicatorPosition] = useState({
    width: 0,
    left: 0,
  });

  const updateUnderline = useCallback(
    (
      tabIndex: string | number | undefined,
      currentIndexNum: string | number | undefined,
    ) => {
      const tabId = getTabId(tabIndex, currentIndexNum);
      if (!tabId) {
        return;
      } // Ensure tabId is not undefined

      const tabEl = document.getElementById(tabId);
      if (!tabEl) {
        return;
      } // Ensure tabEl is not null

      const currentTabRectangle = tabEl.getBoundingClientRect();
      const parentRectangle = (
        tabListRef.current as $TSFixMe
      )?.getBoundingClientRect();
      if (!parentRectangle) {
        return;
      } // Ensure parentRectangle is not null

      setAnimatedIndicatorPosition({
        width: currentTabRectangle.width,
        left: currentTabRectangle.left - parentRectangle.left,
      });
    },
    [],
  );

  useEffect(() => {
    updateUnderline(id, currentIndex);
  }, [id, currentIndex, children, updateUnderline]);

  useEffect(() => {
    const div = tabListRef.current as $TSFixMe;
    const handleScrollEnd = () => updateUnderline(id, currentIndex);
    if (div) {
      div.addEventListener('scrollend', handleScrollEnd);
    }

    return () => {
      if (div) {
        div.removeEventListener('scrollend', handleScrollEnd);
      }
    };
  }, [id, currentIndex, updateUnderline]);

  return (
    <div
      className={cx(
        stylesheet.wrapper,
        orientation !== 'vertical' && stylesheet.horizontal,
      )}
    >
      {isLeftOverflow && (
        <div className={cx(stylesheet.overflowNav, stylesheet.overflowLeft)} />
      )}

      <div
        {...props}
        role="tablist"
        // @ts-expect-error TS(2322) FIXME: Type 'MutableRefObject<undefined>' is not assignab... Remove this comment to see the full error message
        ref={tabListRef}
        className={cx(
          className,
          stylesheet.tabList,
          variant === 'chips' && stylesheet.chips,
          orientation === 'vertical' && stylesheet.vertical,
        )}
        onKeyDown={chainHandlers(onKeyDown, handleKeyDown)}
        onScroll={setOverflows}
        children={cloned}
      />
      {showTabIndicator && (
        <span
          className={stylesheet.tabIndicator}
          style={{
            width: animatedIndicatorPosition.width + 'px',
            left: animatedIndicatorPosition.left + 'px',
          }}
        />
      )}
      {isRightOverflow && (
        <div className={cx(stylesheet.overflowNav, stylesheet.overflowRight)} />
      )}
    </div>
  );
};

export default TabList;
